<template lang="html">
  <div class="card card-chat">
    <div class="card-header">
      <h4 class="card-title">Messages</h4>
      <p class="category">précédents</p>
    </div>
    <div class="card-content">
      <ol class="chat">
        <li class="other">
          <div class="avatar">
            <img src="static/img/faces/face-2.jpg" alt="crash"/>
          </div>
          <div class="msg">
            <p>
              Hola!
              How are you?
            </p>
            <div class="card-footer">
              <i class="ti-check"></i>
              <h6>11:20</h6>
            </div>
          </div>
        </li>
        <li class="self">
          <div class="msg">
            <p>
              Puff...
              I'm alright. How are you?
            </p>
            <div class="card-footer">
              <i class="ti-check"></i>
              <h6>11:22</h6>
            </div>
          </div>
          <div class="avatar">
            <img src="static/img/default-avatar.png" alt="crash"/>
          </div>
        </li>
        <li class="other">
          <div class="avatar">
            <img src="static/img/faces/face-2.jpg" alt="crash"/>
          </div>
          <div class="msg">
            <p>
              I'm ok too!
            </p>
            <div class="card-footer">
              <i class="ti-check"></i>
              <h6>11:24</h6>
            </div>
          </div>
        </li>
        <li class="self">
          <div class="msg">
            <p>
              Well, it was nice hearing from you.
            </p>
            <div class="card-footer">
              <i class="ti-check"></i>
              <h6>11:25</h6>
            </div>
          </div>
          <div class="no-avatar"></div>
        </li>
        <li class="self">
          <div class="msg">
            <p>
              OK, bye-bye
              See you!
            </p>
            <div class="card-footer">
              <i class="ti-check"></i>
              <h6>11:25</h6>
            </div>
          </div>
          <div class="avatar">
            <img src="static/img/default-avatar.png" alt="crash"/>
          </div>
        </li>
      </ol>
      <hr>
      <div class="send-message">
        <div class="avatar">
          <img :src="picture ? picture : 'static/img/default-avatar.png'" alt="crash"/>
        </div>
        <input v-model="message" class="form-control textarea" type="text" placeholder="Tapez votre message!"/>
        <div class="send-button">
          <button :disabled="message.length === 0" @click="send" class="btn btn-primary btn-fill">Envoyer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      message: ''
    }
  },
  computed: {
    ...mapGetters('profiles', {
      profile: 'mine'
    }),
    picture () {
      return this.profile ? this.profile.photoURL : null
    }
  },
  methods: {
    ...mapActions([
      'storeMessagesAdd'
    ]),
    send () {
      const message = {
        author: this.profile._key,
        message: this.message,
        deleted: false,
        created: new Date()
      }
      this.storeMessagesAdd(this.store._key, message)
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Store/Messages.vue